import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
} from "@babackapp/ui/components/pagination";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useReturnRequestsFilters } from "../../../providers/use-return-requests-filters";

type ReturnRequestsPaginationProps = {
  canGoNext?: boolean;
};

export function ReturnRequestsPagination({
  canGoNext,
}: ReturnRequestsPaginationProps) {
  const { page, setPage } = useReturnRequestsFilters();

  const canGoPrevious = page > 1;

  const items = [];

  if (canGoPrevious) {
    items.push(
      <PaginationItem key="previous-button" onClick={() => setPage(page - 1)}>
        <ArrowLeft />
      </PaginationItem>,
    );
  }

  items.push(
    <PaginationItem key="current">
      <PaginationLink isActive>{page}</PaginationLink>
    </PaginationItem>,
  );

  if (canGoNext) {
    items.push(
      <PaginationItem key="next-button" onClick={() => setPage(page + 1)}>
        <ArrowRight />
      </PaginationItem>,
    );
  }

  return (
    <div className="w-full">
      <Pagination>
        <PaginationContent>{items}</PaginationContent>
      </Pagination>
    </div>
  );
}
